import { api } from './client'

export interface DemoRequestPayload {
  firstName: string
  lastName: string
  email: string
  phone?: string
  businessName?: string
  note?: string
  source?: string
  locale?: string
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
}

export const demoRequestsApi = {
  create: (data: DemoRequestPayload) =>
    api.post<{ id: string; sent: boolean }>('/demo-requests', data),
}
